













import { Component, Prop } from 'nuxt-property-decorator'
import { ComponentVue } from '@/base'

@Component
export default class AtomChipFill extends ComponentVue {
  @Prop({ type: String })
  color!: string

  get textColor(): string {
    return this.color === 'red' ? 'white' : 'black'
  }
}
